import { render, staticRenderFns } from "./select-label.vue?vue&type=template&id=6e3d8c8c&scoped=true"
import script from "./select-label.vue?vue&type=script&lang=js"
export * from "./select-label.vue?vue&type=script&lang=js"
import style0 from "./select-label.vue?vue&type=style&index=0&id=6e3d8c8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3d8c8c",
  null
  
)

export default component.exports